__turbopack_context__.v({
  "label": "RepairRequestReturnMethodSummary-module-scss-module__P0UEAG__label",
  "wrapper": "RepairRequestReturnMethodSummary-module-scss-module__P0UEAG__wrapper",
});
